<template>
    <div class="job-management">
      <div class="main-content">
        <h1 class="page-title">My jobs</h1>
  
        <!-- Tab Navigation -->
        <div class="tab-navigation">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab-button', { active: activeTab === tab.id }]"
            @click="activeTab = tab.id"
          >
            {{ tab.name }}
            <span class="tab-count">{{ tab.count }}</span>
          </button>
        </div>
  
        <!-- Current Jobs Tab -->
        <div v-if="activeTab === 'current'" class="tab-content">
          
  
          <!-- Empty state -->
          <div v-if="currentJobs.length === 0" class="empty-state">
            <div class="empty-icon">
              <svg
                width="49"
                height="48"
                viewBox="0 0 49 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M44.4795 12.0419C44.5195 12.5219 44.4795 13.0219 44.3595 13.5219L37.6195 40.5818C37.1395 42.6018 35.3395 44.0018 33.2595 44.0018H6.97948C3.95948 44.0018 1.81951 41.0418 2.69951 38.1418L11.1195 11.0818C11.6995 9.20179 13.4395 7.92188 15.3995 7.92188H39.9995C41.9195 7.92188 43.4795 9.06187 44.1395 10.6619C44.3395 11.0819 44.4395 11.5619 44.4795 12.0419Z"
                  fill="#555C74"
                />
                <path
                  d="M46.4817 39.24C46.6817 41.82 44.6417 44 42.0617 44H33.2617C35.3417 44 37.1417 42.6 37.6217 40.58L44.3617 13.52C44.4817 13.02 44.5217 12.52 44.4817 12.04L44.5017 12L46.4817 39.24Z"
                  fill="#555C74"
                />
                <path
                  d="M19.8595 14.2588C19.7395 14.2588 19.6195 14.2388 19.4995 14.2188C18.6995 14.0188 18.1996 13.2188 18.3996 12.3988L20.4795 3.7588C20.6795 2.9588 21.4795 2.47882 22.2995 2.65882C23.0995 2.85882 23.5996 3.65877 23.3996 4.47877L21.3196 13.1188C21.1596 13.7988 20.5395 14.2588 19.8595 14.2588Z"
                  fill="#555C74"
                />
                <path
                  d="M33.2589 14.2796C33.1589 14.2796 33.0389 14.2796 32.9389 14.2396C32.1389 14.0596 31.6189 13.2595 31.7789 12.4595L33.6589 3.7796C33.8389 2.9596 34.6389 2.45957 35.4389 2.61957C36.2389 2.79957 36.7589 3.5996 36.5989 4.3996L34.7189 13.0795C34.5789 13.7995 33.9589 14.2796 33.2589 14.2796Z"
                  fill="#555C74"
                />
                <path
                  d="M31.8984 25.5H15.8984C15.0784 25.5 14.3984 24.82 14.3984 24C14.3984 23.18 15.0784 22.5 15.8984 22.5H31.8984C32.7184 22.5 33.3984 23.18 33.3984 24C33.3984 24.82 32.7184 25.5 31.8984 25.5Z"
                  fill="#555C74"
                />
                <path
                  d="M29.8984 33.5H13.8984C13.0784 33.5 12.3984 32.82 12.3984 32C12.3984 31.18 13.0784 30.5 13.8984 30.5H29.8984C30.7184 30.5 31.3984 31.18 31.3984 32C31.3984 32.82 30.7184 33.5 29.8984 33.5Z"
                  fill="#555C74"
                />
              </svg>
            </div>
            <h3 class="empty-title">No current jobs</h3>
            <p class="empty-description">Your accepted jobs will appear here.</p>
          </div>
  
          <!-- Job cards -->
          <div  v-for="job in currentJobs" :key="job.id" class="job-card">
            <div class="job-header">
              <div class="job-info">
                <div class="job-title">
                  Request from {{ job.client.firstname }}
                  {{ job.client.lastname }}
                </div>
                <div class="job-date">
                  {{ job.scheduled_date | moment }} |
                  {{ job.schedule_start_time }}
                </div>
              </div>
              <button class="details-toggle" @click="toggleDetails(job.id)">
                Details
                <span :class="['chevron', { expanded: isDetailsOpen(job.id) }]">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.5984 7.46094L11.1651 12.8943C10.5234 13.5359 9.47344 13.5359 8.83177 12.8943L3.39844 7.46094"
                      stroke="#535862"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
  
            <div v-if="!isDetailsOpen(job.id)" class="job-actions">
              <button class="btn btn-primary" @click="openMarkAsDoneModal(job)">
                Mark as done
              </button>
              <button class="btn btn-secondary" @click="openRescheduleModal(job)">
                Reschedule
              </button>
              <button class="btn btn-outline">Cancel</button>
            </div>
  
            <div v-if="isDetailsOpen(job.id)" class="job-details">
              <div class="customer-profile">
                <img
                  src="@/assets/profileImage.jpg"
                  alt="User profile image"
                  class="avatar"
                />
                <div class="customer-info">
                  <div class="customer-name">
                    {{ job.client.firstname }} {{ job.client.lastname }}
                  </div>
                  <div class="rating">
                    <span
                      v-for="n in 5"
                      :key="n"
                      :class="['star', { filled: n <= job.customer_rating }]"
                      ><svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.3046 4.68344L20.6513 9.37677C20.9713 10.0301 21.8246 10.6568 22.5446 10.7768L26.7979 11.4834C29.5179 11.9368 30.1579 13.9101 28.1979 15.8568L24.8913 19.1634C24.3313 19.7234 24.0246 20.8034 24.1979 21.5768L25.1446 25.6701C25.8913 28.9101 24.1713 30.1634 21.3046 28.4701L17.3179 26.1101C16.5979 25.6834 15.4113 25.6834 14.6779 26.1101L10.6913 28.4701C7.83793 30.1634 6.10459 28.8968 6.85126 25.6701L7.79793 21.5768C7.97126 20.8034 7.66459 19.7234 7.10459 19.1634L3.79793 15.8568C1.85126 13.9101 2.47793 11.9368 5.19793 11.4834L9.45126 10.7768C10.1579 10.6568 11.0113 10.0301 11.3313 9.37677L13.6779 4.68344C14.9579 2.13677 17.0379 2.13677 18.3046 4.68344Z"
                          fill="#F5F5F5"
                          stroke="#F5F5F5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span class="rating-value">{{
                      (job.rating || 0).toFixed(1)
                    }}</span>
                  </div>
                </div>
              </div>
  
              <div class="detail-tabs">
                <button
                  :class="[
                    'detail-tab',
                    { active: getActiveTab(job.id) === 'details' },
                  ]"
                  @click="setActiveTab(job.id, 'details')"
                >
                  Details
                </button>
                <button
                  :class="[
                    'detail-tab',
                    { active: getActiveTab(job.id) === 'images' },
                  ]"
                  @click="setActiveTab(job.id, 'images')"
                >
                  Images
                </button>
              </div>
  
              <div
                v-if="getActiveTab(job.id) === 'details'"
                class="detail-content"
              >
                <p class="job-description">{{ job.details }}</p>
  
                <div class="detail-grid">
                  <div class="detail-row">
                    <div class="detail-label">Service type</div>
                    <div class="detail-value">{{ job.service.name }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Customer name</div>
                    <div class="detail-value">
                      {{ job.client.firstname }} {{ job.client.lastname }}
                    </div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Scheduled date and time</div>
                    <div class="detail-value">
                      {{ job.schedule_date | moment }} |
                      {{ job.schedule_start_time }}
                    </div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Location/address</div>
                    <div class="detail-value">
                      {{ job.client_address }}
                    </div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Email address</div>
                    <div class="detail-value">{{ job.client.email }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Phone number</div>
                    <div class="detail-value">{{ job.client.phone }}</div>
                  </div>
                </div>
              </div>
  
              <div
                v-if="getActiveTab(job.id) === 'images'"
                class="detail-content"
              >
                <div class="image-grid">
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
  
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
  
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
                </div>
              </div>
  
              <div class="job-actions">
                <button class="btn btn-primary" @click="openMarkAsDoneModal(job)">
                  Mark as done
                </button>
                <button
                  class="btn btn-secondary"
                  @click="openRescheduleModal(job)"
                >
                  Reschedule
                </button>
                <button class="btn btn-outline">Cancel</button>
              </div>
            </div>
          </div>
        </div>
  
        <!-- New Requests Tab -->
        <div v-if="activeTab === 'new'" class="tab-content">
          <!-- Empty state -->
          <div v-if="newRequests.length === 0" class="empty-state">
            <div class="empty-icon">
              <svg
                width="49"
                height="48"
                viewBox="0 0 49 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M44.4795 12.0419C44.5195 12.5219 44.4795 13.0219 44.3595 13.5219L37.6195 40.5818C37.1395 42.6018 35.3395 44.0018 33.2595 44.0018H6.97948C3.95948 44.0018 1.81951 41.0418 2.69951 38.1418L11.1195 11.0818C11.6995 9.20179 13.4395 7.92188 15.3995 7.92188H39.9995C41.9195 7.92188 43.4795 9.06187 44.1395 10.6619C44.3395 11.0819 44.4395 11.5619 44.4795 12.0419Z"
                  fill="#555C74"
                />
                <path
                  d="M46.4817 39.24C46.6817 41.82 44.6417 44 42.0617 44H33.2617C35.3417 44 37.1417 42.6 37.6217 40.58L44.3617 13.52C44.4817 13.02 44.5217 12.52 44.4817 12.04L44.5017 12L46.4817 39.24Z"
                  fill="#555C74"
                />
                <path
                  d="M19.8595 14.2588C19.7395 14.2588 19.6195 14.2388 19.4995 14.2188C18.6995 14.0188 18.1996 13.2188 18.3996 12.3988L20.4795 3.7588C20.6795 2.9588 21.4795 2.47882 22.2995 2.65882C23.0995 2.85882 23.5996 3.65877 23.3996 4.47877L21.3196 13.1188C21.1596 13.7988 20.5395 14.2588 19.8595 14.2588Z"
                  fill="#555C74"
                />
                <path
                  d="M33.2589 14.2796C33.1589 14.2796 33.0389 14.2796 32.9389 14.2396C32.1389 14.0596 31.6189 13.2595 31.7789 12.4595L33.6589 3.7796C33.8389 2.9596 34.6389 2.45957 35.4389 2.61957C36.2389 2.79957 36.7589 3.5996 36.5989 4.3996L34.7189 13.0795C34.5789 13.7995 33.9589 14.2796 33.2589 14.2796Z"
                  fill="#555C74"
                />
                <path
                  d="M31.8984 25.5H15.8984C15.0784 25.5 14.3984 24.82 14.3984 24C14.3984 23.18 15.0784 22.5 15.8984 22.5H31.8984C32.7184 22.5 33.3984 23.18 33.3984 24C33.3984 24.82 32.7184 25.5 31.8984 25.5Z"
                  fill="#555C74"
                />
                <path
                  d="M29.8984 33.5H13.8984C13.0784 33.5 12.3984 32.82 12.3984 32C12.3984 31.18 13.0784 30.5 13.8984 30.5H29.8984C30.7184 30.5 31.3984 31.18 31.3984 32C31.3984 32.82 30.7184 33.5 29.8984 33.5Z"
                  fill="#555C74"
                />
              </svg>
            </div>
            <h3 class="empty-title">No request</h3>
            <p class="empty-description">
              You will see new job requests from clients here as they come in.
            </p>
          </div>
  
          <!-- Job cards -->
          <div v-for="job in newRequests" :key="job.id" class="job-card">
            <div class="job-header">
              <div class="job-info">
                <div class="job-title">Request from {{ job.customer_name }}</div>
                <div class="job-date">{{ job.scheduled_date }}</div>
              </div>
              <button class="details-toggle" @click="toggleDetails(job.id)">
                Details
                <span :class="['chevron', { expanded: isDetailsOpen(job.id) }]">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.5984 7.46094L11.1651 12.8943C10.5234 13.5359 9.47344 13.5359 8.83177 12.8943L3.39844 7.46094"
                      stroke="#535862"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg
                ></span>
              </button>
            </div>
  
            <div v-if="!isDetailsOpen(job.id)" class="job-actions">
              <button class="btn btn-primary" @click="openAcceptModal(job)">
                Accept
              </button>
              <button class="btn btn-secondary" @click="openRescheduleModal(job)">
                Reschedule
              </button>
              <button class="btn btn-outline" @click="openDeclineModal(job)">
                Decline
              </button>
            </div>
  
            <div v-if="isDetailsOpen(job.id)" class="job-details">
              <div class="customer-profile">
                <img
                    src="@/assets/profileImage.jpg"
                    :alt="job.client.firstname"
                    class="avatar"
                />
                <div class="customer-info">
                  <div class="customer-name">{{ job.customer_name }}</div>
                  <div class="rating">
                    <span
                      v-for="n in 5"
                      :key="n"
                      :class="['star', { filled: n <= job.customer_rating }]"
                      ><svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.3046 4.68344L20.6513 9.37677C20.9713 10.0301 21.8246 10.6568 22.5446 10.7768L26.7979 11.4834C29.5179 11.9368 30.1579 13.9101 28.1979 15.8568L24.8913 19.1634C24.3313 19.7234 24.0246 20.8034 24.1979 21.5768L25.1446 25.6701C25.8913 28.9101 24.1713 30.1634 21.3046 28.4701L17.3179 26.1101C16.5979 25.6834 15.4113 25.6834 14.6779 26.1101L10.6913 28.4701C7.83793 30.1634 6.10459 28.8968 6.85126 25.6701L7.79793 21.5768C7.97126 20.8034 7.66459 19.7234 7.10459 19.1634L3.79793 15.8568C1.85126 13.9101 2.47793 11.9368 5.19793 11.4834L9.45126 10.7768C10.1579 10.6568 11.0113 10.0301 11.3313 9.37677L13.6779 4.68344C14.9579 2.13677 17.0379 2.13677 18.3046 4.68344Z"
                          fill="#F5F5F5"
                          stroke="#F5F5F5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span class="rating-value">{{
                      job.customer_rating.toFixed(1)
                    }}</span>
                  </div>
                </div>
              </div>
  
              <div class="detail-tabs">
                <button
                  :class="[
                    'detail-tab',
                    { active: getActiveTab(job.id) === 'details' },
                  ]"
                  @click="setActiveTab(job.id, 'details')"
                >
                  Details
                </button>
                <button
                  :class="[
                    'detail-tab',
                    { active: getActiveTab(job.id) === 'images' },
                  ]"
                  @click="setActiveTab(job.id, 'images')"
                >
                  Images
                </button>
              </div>
  
              <div
                v-if="getActiveTab(job.id) === 'details'"
                class="detail-content"
              >
                <p class="job-description">
                  {{ job.description }} 
                </p>
  
                <div class="detail-grid">
                  <div class="detail-row">
                    <div class="detail-label">Service type</div>
                    <div class="detail-value">{{ job.service_type }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Customer name</div>
                    <div class="detail-value">{{ job.customer_name }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Scheduled date and time</div>
                    <div class="detail-value">{{ job.scheduled_date_time }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Location/address</div>
                    <div class="detail-value">{{ job.address }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Email address</div>
                    <div class="detail-value">{{ job.customer_email }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Phone number</div>
                    <div class="detail-value">{{ job.customer_phone }}</div>
                  </div>
                </div>
              </div>
  
              <div
                v-if="getActiveTab(job.id) === 'images'"
                class="detail-content"
              >
                 <div class="image-grid">
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
  
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
  
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
                </div>
              </div>
  
              <div class="job-actions">
                <button class="btn btn-primary" @click="openAcceptModal(job)">
                  Accept
                </button>
                <button
                  class="btn btn-secondary"
                  @click="openRescheduleModal(job)"
                >
                  Reschedule
                </button>
                <button class="btn btn-outline" @click="openDeclineModal(job)">
                  Decline
                </button>
              </div>
            </div>
          </div>
        </div>
  
        <!-- History Tab -->
        <div v-if="activeTab === 'history'" class="tab-content">
         
  
          <!-- Empty state -->
          <div v-if="historyJobs.length === 0" class="empty-state">
            <div class="empty-icon">
              <svg
                width="49"
                height="48"
                viewBox="0 0 49 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M44.4795 12.0419C44.5195 12.5219 44.4795 13.0219 44.3595 13.5219L37.6195 40.5818C37.1395 42.6018 35.3395 44.0018 33.2595 44.0018H6.97948C3.95948 44.0018 1.81951 41.0418 2.69951 38.1418L11.1195 11.0818C11.6995 9.20179 13.4395 7.92188 15.3995 7.92188H39.9995C41.9195 7.92188 43.4795 9.06187 44.1395 10.6619C44.3395 11.0819 44.4395 11.5619 44.4795 12.0419Z"
                  fill="#555C74"
                />
                <path
                  d="M46.4817 39.24C46.6817 41.82 44.6417 44 42.0617 44H33.2617C35.3417 44 37.1417 42.6 37.6217 40.58L44.3617 13.52C44.4817 13.02 44.5217 12.52 44.4817 12.04L44.5017 12L46.4817 39.24Z"
                  fill="#555C74"
                />
                <path
                  d="M19.8595 14.2588C19.7395 14.2588 19.6195 14.2388 19.4995 14.2188C18.6995 14.0188 18.1996 13.2188 18.3996 12.3988L20.4795 3.7588C20.6795 2.9588 21.4795 2.47882 22.2995 2.65882C23.0995 2.85882 23.5996 3.65877 23.3996 4.47877L21.3196 13.1188C21.1596 13.7988 20.5395 14.2588 19.8595 14.2588Z"
                  fill="#555C74"
                />
                <path
                  d="M33.2589 14.2796C33.1589 14.2796 33.0389 14.2796 32.9389 14.2396C32.1389 14.0596 31.6189 13.2595 31.7789 12.4595L33.6589 3.7796C33.8389 2.9596 34.6389 2.45957 35.4389 2.61957C36.2389 2.79957 36.7589 3.5996 36.5989 4.3996L34.7189 13.0795C34.5789 13.7995 33.9589 14.2796 33.2589 14.2796Z"
                  fill="#555C74"
                />
                <path
                  d="M31.8984 25.5H15.8984C15.0784 25.5 14.3984 24.82 14.3984 24C14.3984 23.18 15.0784 22.5 15.8984 22.5H31.8984C32.7184 22.5 33.3984 23.18 33.3984 24C33.3984 24.82 32.7184 25.5 31.8984 25.5Z"
                  fill="#555C74"
                />
                <path
                  d="M29.8984 33.5H13.8984C13.0784 33.5 12.3984 32.82 12.3984 32C12.3984 31.18 13.0784 30.5 13.8984 30.5H29.8984C30.7184 30.5 31.3984 31.18 31.3984 32C31.3984 32.82 30.7184 33.5 29.8984 33.5Z"
                  fill="#555C74"
                />
              </svg>
            </div>
            <h3 class="empty-title">No history</h3>
            <p class="empty-description">Your completed jobs will appear here.</p>
          </div>
  
          <!-- Job cards -->
          <div  v-for="job in historyJobs" :key="job.id" class="job-card">
            <div class="job-header">
              <div class="job-info">
                <div class="job-title">Request from {{ job.client.firstname }} {{ job.client.lastname}}</div>
                <div class="job-date">{{ job.scheduled_date }}</div>
                <div v-if="job.has_rated" class="rating-info">
                  You rated {{ job.client.firstname }} {{ job.client.lastname }}:
                  <span
                    v-for="n in 5"
                    :key="n"
                    :class="['star small', { filled: n <= job.your_rating }]"
                    ><svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.3046 4.68344L20.6513 9.37677C20.9713 10.0301 21.8246 10.6568 22.5446 10.7768L26.7979 11.4834C29.5179 11.9368 30.1579 13.9101 28.1979 15.8568L24.8913 19.1634C24.3313 19.7234 24.0246 20.8034 24.1979 21.5768L25.1446 25.6701C25.8913 28.9101 24.1713 30.1634 21.3046 28.4701L17.3179 26.1101C16.5979 25.6834 15.4113 25.6834 14.6779 26.1101L10.6913 28.4701C7.83793 30.1634 6.10459 28.8968 6.85126 25.6701L7.79793 21.5768C7.97126 20.8034 7.66459 19.7234 7.10459 19.1634L3.79793 15.8568C1.85126 13.9101 2.47793 11.9368 5.19793 11.4834L9.45126 10.7768C10.1579 10.6568 11.0113 10.0301 11.3313 9.37677L13.6779 4.68344C14.9579 2.13677 17.0379 2.13677 18.3046 4.68344Z"
                        fill="#F5F5F5"
                        stroke="#F5F5F5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  {{ job.your_rating.toFixed(1) }}
                </div>
              </div>
              <button class="details-toggle" @click="toggleDetails(job.id)">
                Details
                <span :class="['chevron', { expanded: isDetailsOpen(job.id) }]">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.5984 7.46094L11.1651 12.8943C10.5234 13.5359 9.47344 13.5359 8.83177 12.8943L3.39844 7.46094"
                      stroke="#535862"
                      stroke-width="1.6"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg
                ></span>
              </button>
            </div>
  
            <div
              v-if="!isDetailsOpen(job.id) && !job.has_rated"
              class="job-actions"
            >
              <button class="btn btn-outline" @click="openRatingModal(job)">
                Rate
              </button>
            </div>
  
            <div v-if="isDetailsOpen(job.id)" class="job-details">
              <div class="customer-profile">
                <img
                  src="@/assets/profileImage.jpg"
                  :alt="job.client.firstname"
                  class="avatar"
                />
                <div class="customer-info">
                  <div class="customer-name">{{ job.client.firstname }} {{ job.client.lastname}}</div>
                  <div class="rating">
                    <span
                      v-for="n in 5"
                      :key="n"
                      :class="['star', { filled: n <= job.customer_rating }]"
                      ><svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.3046 4.68344L20.6513 9.37677C20.9713 10.0301 21.8246 10.6568 22.5446 10.7768L26.7979 11.4834C29.5179 11.9368 30.1579 13.9101 28.1979 15.8568L24.8913 19.1634C24.3313 19.7234 24.0246 20.8034 24.1979 21.5768L25.1446 25.6701C25.8913 28.9101 24.1713 30.1634 21.3046 28.4701L17.3179 26.1101C16.5979 25.6834 15.4113 25.6834 14.6779 26.1101L10.6913 28.4701C7.83793 30.1634 6.10459 28.8968 6.85126 25.6701L7.79793 21.5768C7.97126 20.8034 7.66459 19.7234 7.10459 19.1634L3.79793 15.8568C1.85126 13.9101 2.47793 11.9368 5.19793 11.4834L9.45126 10.7768C10.1579 10.6568 11.0113 10.0301 11.3313 9.37677L13.6779 4.68344C14.9579 2.13677 17.0379 2.13677 18.3046 4.68344Z"
                          fill="#F5F5F5"
                          stroke="#F5F5F5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span class="rating-value">{{
                      job.customer_rating.toFixed(1)
                    }}</span>
                  </div>
                </div>
              </div>
  
              <div class="detail-tabs">
                <button
                  :class="[
                    'detail-tab',
                    { active: getActiveTab(job.id) === 'details' },
                  ]"
                  @click="setActiveTab(job.id, 'details')"
                >
                  Details
                </button>
                <button
                  :class="[
                    'detail-tab',
                    { active: getActiveTab(job.id) === 'images' },
                  ]"
                  @click="setActiveTab(job.id, 'images')"
                >
                  Images
                </button>
              </div>
  
              <div
                v-if="getActiveTab(job.id) === 'details'"
                class="detail-content"
              >
                <p class="job-description">
                  {{ job.description }} 
                </p>
  
                <div class="detail-grid">
                  <div class="detail-row">
                    <div class="detail-label">Service type</div>
                    <div class="detail-value">{{ job.service.name }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Customer name</div>
                    <div class="detail-value">{{ job.client.firstname }} {{ job.client.lastname}}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Scheduled date and time</div>
                    <div class="detail-value">{{ job.scheduled_date | moment }} {{ job.schedule_start_time}}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Location/address</div>
                    <div class="detail-value">{{ job.client_address }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Email address</div>
                    <div class="detail-value">{{ job.client.email }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">Phone number</div>
                    <div class="detail-value">{{ job.client.phone }}</div>
                  </div>
                </div>
              </div>
  
              <div
                v-if="getActiveTab(job.id) === 'images'"
                class="detail-content"
              >
                 <div class="image-grid">
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
  
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
  
                  <img
                    src="../../src/assets/images/hero-houses.jpg"
                    alt="Job image"
                    class="job-image"
                  />
                </div>
              </div>
  
              <div v-if="!job.has_rated" class="job-actions">
                <button class="btn btn-outline" @click="openRatingModal(job)">
                  Rate
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- MODALS - Only show when explicitly triggered -->
      <!-- Accept Request Modal -->
      <div
        v-if="showAcceptModal"
        class="simple-modal-backdrop"
        @click="closeAcceptModal"
      >
        <div class="simple-modal-content" @click.stop>
          <div class="simple-modal-header">
            <h3>Accept request</h3>
            <button @click="closeAcceptModal" class="simple-close-btn">×</button>
          </div>
          <div class="simple-modal-body">
            <div class="request-info">
              <div class="request-title">
                Request for {{ selectedJob.service_type }} from
                {{ selectedJob.customer_name }}
              </div>
              <div class="request-details">
                <span
                  ><svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.33203 1.33594V3.33594"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.668 1.33594V3.33594"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.33203 6.0625H13.6654"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14 5.66927V11.3359C14 13.3359 13 14.6693 10.6667 14.6693H5.33333C3 14.6693 2 13.3359 2 11.3359V5.66927C2 3.66927 3 2.33594 5.33333 2.33594H10.6667C13 2.33594 14 3.66927 14 5.66927Z"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4664 9.13021H10.4724"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4664 11.1302H10.4724"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.99764 9.13021H8.00363"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.99764 11.1302H8.00363"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.52889 9.13021H5.53488"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.52889 11.1302H5.53488"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{ selectedJob.scheduled_date }}</span
                >
                <span
                  ><svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6654 8.0026C14.6654 11.6826 11.6787 14.6693 7.9987 14.6693C4.3187 14.6693 1.33203 11.6826 1.33203 8.0026C1.33203 4.3226 4.3187 1.33594 7.9987 1.33594C11.6787 1.33594 14.6654 4.3226 14.6654 8.0026Z"
                      stroke="#555C74"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4739 10.1211L8.40724 8.88781C8.04724 8.67448 7.75391 8.16115 7.75391 7.74115V5.00781"
                      stroke="#555C74"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{ selectedJob.scheduled_time }}</span
                >
              </div>
            </div>
            <div class="form-group">
              <label>Leave any comment</label>
              <textarea
                v-model="formData.acceptComment"
                placeholder="Add any special instructions or notes here..."
                rows="4"
              ></textarea>
            </div>
          </div>
          <div class="simple-modal-footer">
            <button class="btn btn-primary btn-full" @click="confirmAcceptJob">
              Accept request
            </button>
          </div>
        </div>
      </div>
  
      <!-- Mark as Done Modal -->
      <div
        v-if="showMarkDoneModal"
        class="simple-modal-backdrop"
        @click="closeMarkDoneModal"
      >
        <div class="simple-modal-content" @click.stop>
          <div class="simple-modal-header">
            <h3>Mark as done</h3>
            <button @click="closeMarkDoneModal" class="simple-close-btn">
              ×
            </button>
          </div>
          <div class="simple-modal-body">
            <p>Are you sure you want to mark this service as completed?</p>
          </div>
          <div class="simple-modal-footer">
            <button class="btn btn-outline" @click="closeMarkDoneModal">
              No, cancel
            </button>
            <button class="btn btn-primary" @click="proceedMarkAsDone">
              Yes, proceed
            </button>
          </div>
        </div>
      </div>
  
      <!-- Service Completed Modal -->
      <div
        v-if="showCompletedModal"
        class="simple-modal-backdrop"
        @click="closeCompletedModal"
      >
        <div class="simple-modal-content" @click.stop>
          <div class="simple-modal-header">
            <button @click="closeCompletedModal" class="simple-close-btn">
              ×
            </button>
          </div>
          <div class="simple-modal-body text-center">
            <div class="success-icon">
              <svg
                width="100"
                height="100"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="50"
                  fill="#2BC300"
                  fill-opacity="0.12"
                />
                <path
                  d="M50 10C27.96 10 10 27.96 10 50C10 72.04 27.96 90 50 90C72.04 90 90 72.04 90 50C90 27.96 72.04 10 50 10ZM69.12 40.8L46.44 63.48C45.88 64.04 45.12 64.36 44.32 64.36C43.52 64.36 42.76 64.04 42.2 63.48L30.88 52.16C29.72 51 29.72 49.08 30.88 47.92C32.04 46.76 33.96 46.76 35.12 47.92L44.32 57.12L64.88 36.56C66.04 35.4 67.96 35.4 69.12 36.56C70.28 37.72 70.28 39.6 69.12 40.8Z"
                  fill="#2BC300"
                />
              </svg>
            </div>
            <h3>Service completed!</h3>
            <p>
              Rate your experience with
              <strong>{{ selectedJob.customer_name }}</strong> and provide
              feedback to help others make informed decisions
            </p>
  
            <div class="star-rating">
              <span
                v-for="n in 5"
                :key="n"
                :class="['rating-star', { active: n <= formData.userRating }]"
                @click="setRating(n)"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3046 4.68344L20.6513 9.37677C20.9713 10.0301 21.8246 10.6568 22.5446 10.7768L26.7979 11.4834C29.5179 11.9368 30.1579 13.9101 28.1979 15.8568L24.8913 19.1634C24.3313 19.7234 24.0246 20.8034 24.1979 21.5768L25.1446 25.6701C25.8913 28.9101 24.1713 30.1634 21.3046 28.4701L17.3179 26.1101C16.5979 25.6834 15.4113 25.6834 14.6779 26.1101L10.6913 28.4701C7.83793 30.1634 6.10459 28.8968 6.85126 25.6701L7.79793 21.5768C7.97126 20.8034 7.66459 19.7234 7.10459 19.1634L3.79793 15.8568C1.85126 13.9101 2.47793 11.9368 5.19793 11.4834L9.45126 10.7768C10.1579 10.6568 11.0113 10.0301 11.3313 9.37677L13.6779 4.68344C14.9579 2.13677 17.0379 2.13677 18.3046 4.68344Z"
                    fill="#F5F5F5"
                    stroke="#F5F5F5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
  
            <div class="form-group">
              <label>Additional feedback</label>
              <textarea
                v-model="formData.completionFeedback"
                placeholder="Enter here..."
                rows="4"
              ></textarea>
            </div>
          </div>
          <div class="simple-modal-footer">
            <button class="btn btn-primary btn-full" @click="submitCompletion">
              Done
            </button>
          </div>
        </div>
      </div>
  
      <!-- Reschedule Modal -->
      <div
        v-if="showRescheduleModal"
        class="simple-modal-backdrop"
        @click="closeRescheduleModal"
      >
        <div class="simple-modal-content" @click.stop>
          <div class="simple-modal-header">
            <h3>Reschedule</h3>
            <button @click="closeRescheduleModal" class="simple-close-btn">
              ×
            </button>
          </div>
          <div class="simple-modal-body">
            <p>
              Propose a new date/time for this service with
              {{ selectedJob.customer_name }}.
            </p>
  
            <div class="example-schedule">
              <div class="example-date">
                <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.33203 1.33594V3.33594"
                    stroke="#555C74"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.668 1.33594V3.33594"
                    stroke="#555C74"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.33203 6.0625H13.6654"
                    stroke="#555C74"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 5.66927V11.3359C14 13.3359 13 14.6693 10.6667 14.6693H5.33333C3 14.6693 2 13.3359 2 11.3359V5.66927C2 3.66927 3 2.33594 5.33333 2.33594H10.6667C13 2.33594 14 3.66927 14 5.66927Z"
                    stroke="#555C74"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.4664 9.13021H10.4724"
                    stroke="#555C74"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.4664 11.1302H10.4724"
                    stroke="#555C74"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.99764 9.13021H8.00363"
                    stroke="#555C74"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.99764 11.1302H8.00363"
                    stroke="#555C74"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.52889 9.13021H5.53488"
                    stroke="#555C74"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.52889 11.1302H5.53488"
                    stroke="#555C74"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{
                  selectedJob.scheduled_date &&
                  selectedJob.scheduled_date.split("|")[0]
                }}</span>
              </div>
  
            <div class="example-time">
                <span
                ><svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.6654 8.0026C14.6654 11.6826 11.6787 14.6693 7.9987 14.6693C4.3187 14.6693 1.33203 11.6826 1.33203 8.0026C1.33203 4.3226 4.3187 1.33594 7.9987 1.33594C11.6787 1.33594 14.6654 4.3226 14.6654 8.0026Z"
                    stroke="#555C74"
                    stroke-width="0.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.4739 10.1211L8.40724 8.88781C8.04724 8.67448 7.75391 8.16115 7.75391 7.74115V5.00781"
                    stroke="#555C74"
                    stroke-width="0.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ selectedJob.scheduled_time }}</span
              >
            </div>
              </div>
  
             
  
            <h4>New schedule details</h4>
              <div class="form-group">
                  <label for="date">Date</label>
                  <div class="form-group">
                    <input type="date" v-model="dateBooked" class="" id="date" placeholder="Select date">
                  </div>
                  
                </div>
   <div class="form-group">
                  <label for="time">Select time</label>
                  <div class="time-select-container">
                    <input
                      type="text"
                      id="time"
                      v-model="timeBooked"
                      readonly
                      @click="showTimeDropdown = !showTimeDropdown"
                    />
                    <div v-if="showTimeDropdown" class="time-dropdown">
                      <div
                        v-for="(item, index) in timeOptions" :key="index"
                        class="time-option"
                        @click="selectTime(item.time)"
                      >
                        {{ item.time }}
                      </div>
                    </div>
                  </div>
                </div>
  
  
          </div>
          <div class="simple-modal-footer">
            <button
              class="btn btn-primary btn-full"
              @click="actions = 'reschedule'; id = this.jobID; "
              :disabled="!formData.rescheduleDate || !formData.rescheduleTime"
            >
              Reschedule
            </button>
          </div>
        </div>
      </div>
  
      <!-- Decline Modal -->
      <div
        v-if="showDeclineModal"
        class="simple-modal-backdrop"
        @click="closeDeclineModal"
      >
        <div class="simple-modal-content" @click.stop>
          <div class="simple-modal-header">
            <h3>Decline</h3>
            <button @click="closeDeclineModal" class="simple-close-btn">×</button>
          </div>
          <div class="simple-modal-body">
            <div class="job-info-header">
              <div>
                {{ selectedJob.service_type }} from
                {{ selectedJob.customer_name }}
              </div>
              <div>
                <span
                  ><svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.33398 1.33203V3.33203"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.666 1.33203V3.33203"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.33398 6.05859H13.6673"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14 5.66536V11.332C14 13.332 13 14.6654 10.6667 14.6654H5.33333C3 14.6654 2 13.332 2 11.332V5.66536C2 3.66536 3 2.33203 5.33333 2.33203H10.6667C13 2.33203 14 3.66536 14 5.66536Z"
                      stroke="#555C74"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4644 9.13411H10.4704"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4644 11.1341H10.4704"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.99569 9.13411H8.00168"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.99569 11.1341H8.00168"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.52694 9.13411H5.53293"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.52694 11.1341H5.53293"
                      stroke="#555C74"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg
                  >{{
                    selectedJob.scheduled_date &&
                    selectedJob.scheduled_date.split("|")[0]
                  }}</span
                >
                <span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6673 7.9987C14.6673 11.6787 11.6807 14.6654 8.00065 14.6654C4.32065 14.6654 1.33398 11.6787 1.33398 7.9987C1.33398 4.3187 4.32065 1.33203 8.00065 1.33203C11.6807 1.33203 14.6673 4.3187 14.6673 7.9987Z"
                      stroke="#555C74"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4759 10.1211L8.40919 8.88781C8.04919 8.67448 7.75586 8.16115 7.75586 7.74115V5.00781"
                      stroke="#555C74"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{ selectedJob.scheduled_time }}</span
                >
              </div>
            </div>
  
            <div class="form-group">
              <label>Why are you unable to proceed with this request? *</label>
              <div class="radio-group">
                <label
                  @click="selectDeclineReason('Insufficient service details')"
                >
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption ===
                      'Insufficient service details'
                    "
                    v-model="this.selectedReason"
                  />
                  Insufficient service details
                </label>
                <label @click="selectDeclineReason('Out of service area')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Out of service area'
                    "
                                      v-model="this.selectedReason"
  
                  />
                  Out of service area
                </label>
                <label @click="selectDeclineReason('Scheduling conflict')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Scheduling conflict'
                    "
                                      v-model="this.selectedReason"
  
                  />
                  Scheduling conflict
                </label>
  
                 <label @click="selectDeclineReason('Unforeseen circumstances')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Unforeseen circumstances'
                    "
                                      v-model="this.selectedReason"
  
                  />
  Unforeseen circumstances              </label>
  
                 <label @click="selectDeclineReason('Incompatible service request')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Incompatible service request'
                    "
                                      v-model="this.selectedReason"
  
                  />
                  Incompatible service request
                </label>
  
                 <label @click="selectDeclineReason('Customer unresponsive')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Customer unresponsive'
                    "
                                      v-model="this.selectedReason"
  
                  />
                  Customer unresponsive
                </label>
  
                 <label @click="selectDeclineReason('Unavailable resources')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Unavailable resources'
                    "
                                      v-model="this.selectedReason"
  
                  />
                  Unavailable resources
                </label>
  
                 <label @click="selectDeclineReason('Payment issues')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Payment issues'
                    "
                                      v-model="this.selectedReason"
  
                  />
                  Payment issues
                </label>
  
                 <label @click="selectDeclineReason('Safety concerns')">
                  <input
                    type="radio"
                    :checked="
                      formData.selectedDeclineOption === 'Safety concerns'
                    "
                                      v-model="this.selectedReason"
  
                  />
                  Safety concerns
                </label>
  
  
  
                <label @click="selectDeclineReason('Other')">
                  <input
                    type="radio"
                    :checked="formData.selectedDeclineOption === 'Other'"
                  />
                  Other
                </label>
              </div>
  
              <div
                v-if="formData.selectedDeclineOption === 'Other'"
                class="form-group"
              >
                <input
                  v-model="formData.declineOtherReason"
                  type="text"
                  placeholder="Enter here..."
                />
              </div>
            </div>
          </div>
          <div class="simple-modal-footer">
            <button
              class="btn btn-red btn-full"
              @click="cancelRequest()"
              :disabled="!isDeclineButtonEnabled"
            >
              Decline
            </button>
          </div>
        </div>
      </div>
  
      <!-- Rating Modal -->
      <div
        v-if="showRatingModal"
        class="simple-modal-backdrop"
        @click="closeRatingModal"
      >
        <div class="simple-modal-content" @click.stop>
          <div class="simple-modal-header">
            <button @click="closeRatingModal" class="simple-close-btn">×</button>
          </div>
          <div class="simple-modal-body text-center">
            <div class="success-icon">
              <svg
                width="100"
                height="100"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="50"
                  fill="#2BC300"
                  fill-opacity="0.12"
                />
                <path
                  d="M50 10C27.96 10 10 27.96 10 50C10 72.04 27.96 90 50 90C72.04 90 90 72.04 90 50C90 27.96 72.04 10 50 10ZM69.12 40.8L46.44 63.48C45.88 64.04 45.12 64.36 44.32 64.36C43.52 64.36 42.76 64.04 42.2 63.48L30.88 52.16C29.72 51 29.72 49.08 30.88 47.92C32.04 46.76 33.96 46.76 35.12 47.92L44.32 57.12L64.88 36.56C66.04 35.4 67.96 35.4 69.12 36.56C70.28 37.72 70.28 39.6 69.12 40.8Z"
                  fill="#2BC300"
                />
              </svg>
            </div>
            <h3>Service completed!</h3>
            <p>
              Rate your experience with
              <strong>{{ ratingJobData.customer_name }}</strong> and provide
              feedback to help others make informed decisions
            </p>
  
            <div class="star-rating">
              <span
                v-for="n in 5"
                :key="n"
                :class="['rating-star', { active: n <= formData.userRating }]"
                @click="setRating(n)"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3046 4.68344L20.6513 9.37677C20.9713 10.0301 21.8246 10.6568 22.5446 10.7768L26.7979 11.4834C29.5179 11.9368 30.1579 13.9101 28.1979 15.8568L24.8913 19.1634C24.3313 19.7234 24.0246 20.8034 24.1979 21.5768L25.1446 25.6701C25.8913 28.9101 24.1713 30.1634 21.3046 28.4701L17.3179 26.1101C16.5979 25.6834 15.4113 25.6834 14.6779 26.1101L10.6913 28.4701C7.83793 30.1634 6.10459 28.8968 6.85126 25.6701L7.79793 21.5768C7.97126 20.8034 7.66459 19.7234 7.10459 19.1634L3.79793 15.8568C1.85126 13.9101 2.47793 11.9368 5.19793 11.4834L9.45126 10.7768C10.1579 10.6568 11.0113 10.0301 11.3313 9.37677L13.6779 4.68344C14.9579 2.13677 17.0379 2.13677 18.3046 4.68344Z"
                    fill="#F5F5F5"
                    stroke="#F5F5F5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
  
            <div class="form-group">
              <label>Additional feedback</label>
              <textarea
                v-model="formData.completionFeedback"
                placeholder="Enter here..."
                rows="4"
              ></textarea>
            </div>
          </div>
          <div class="simple-modal-footer">
            <button class="btn btn-primary btn-full" @click="submitRating">
              Done
            </button>
          </div>
        </div>
      </div>
  
      <!-- LOADER -->
      <div v-if="loading" class="loading-screen">
        <Loader />
      </div>
    </div>
  </template>
  
  <script>
  import Loader from "../components/Loader.vue";
  import vendorJobs from "../services/vendorsjobs";
  import moment from "moment";
  import agentProfile from "@/services/agentProfile";
  import $ from "jquery";
  export default {
    components: { Loader },
    data() {
      return {
        loading: false,
        activeTab: "new",
        declinedNum: "",
        historyNum: "",
        newRequestNum: "",
        currentJobsNum: "",
        openDetails: {},
        activeDetailTabs: {},
        actions: "",
        jobID :"",
        selectedReason: "",
         selectedTime: "9:00",
               showTimeDropdown: false,
       dateBooked: "",
        timeBooked: "09:00 AM",
        timeOptions: [
          {
            time: "09:00 AM",
          },
          {
            time: "10:00 AM",
          },
          {
            time: "11:00 AM",
          },
          {
            time: "12:00 AM",
          },
          {
            time: "1:00 PM",
          },
          {
            time: "2:00 PM",
          },
          {
            time: "3:00 PM",
          },
          {
            time: "4:00 PM",
          },
          {
            time: "5:00 PM",
          },
        ],
  
        // Modal states 
        showAcceptModal: false,
        showMarkDoneModal: false,
        showCompletedModal: false,
        showRescheduleModal: false,
        showDeclineModal: false,
        showRatingModal: false,
  
        
        formData: {
          acceptComment: "",
          completionFeedback: "",
          userRating: 0,
          rescheduleDate: "",
          rescheduleTime: "",
          selectedDeclineOption: "",
          declineOtherReason: "",
        },
  
        // Selected job for modals
        selectedJob: {},
        ratingJobData: {},
  
        currentJobs: [
  
        ],
  
        newRequests: [
  
        ],
  
        historyJobs: [
          
        ],
      };
    },
    filters: {
      moment: function (date) {
        return moment(date).format("MMMM Do YYYY");
      },
    },
    immediate: true,
    computed: {
      tabs() {
        return [
          { id: "current", name: "Current jobs", count: this.currentJobs.length },
          { id: "new", name: "New requests", count: this.newRequests.length },
          { id: "history", name: "History", count: this.historyJobs.length },
        ];
      },
  
      isDeclineButtonEnabled() {
        return (
          this.formData.selectedDeclineOption &&
          (this.formData.selectedDeclineOption !== "Other" ||
            this.formData.declineOtherReason.trim())
        );
      },
    },
  
    methods: {
      selectTime(time) {
        this.timeBooked = time;
        this.showTimeDropdown = false;
      },
      // Toggle details
      toggleDetails(jobId) {
        if (this.openDetails[jobId]) {
          this.$delete(this.openDetails, jobId);
          this.$delete(this.activeDetailTabs, jobId);
        } else {
          this.$set(this.openDetails, jobId, true);
          this.$set(this.activeDetailTabs, jobId, "details");
        }
      },
  
      isDetailsOpen(jobId) {
        return !!this.openDetails[jobId];
      },
  
      setActiveTab(jobId, tab) {
        this.$set(this.activeDetailTabs, jobId, tab);
      },
  
      getActiveTab(jobId) {
        return this.activeDetailTabs[jobId] || "details";
      },
  
      // ACCEPT MODAL METHODS
      openAcceptModal(job) {
        console.log("Opening accept modal for:", job);
        this.selectedJob = job;
        this.formData.acceptComment = "";
        this.showAcceptModal = true;
      },
  
      closeAcceptModal() {
        this.showAcceptModal = false;
        this.selectedJob = {};
        this.formData.acceptComment = "";
      },
  
      async confirmAcceptJob() {
        const index = this.newRequests.findIndex(
          (j) => j.id === this.selectedJob.id
        );
        if (index !== -1) {
          const acceptedJob = this.newRequests.splice(index, 1)[0];
          acceptedJob.status = "current";
          this.currentJobs.push(acceptedJob);
          this.activeTab = "current";
        }
        this.closeAcceptModal();
      },
  
      // MARK AS DONE MODAL METHODS
      openMarkAsDoneModal(job) {
        this.selectedJob = job;
        this.showMarkDoneModal = true;
      },
  
      closeMarkDoneModal() {
        this.showMarkDoneModal = false;
        this.selectedJob = {};
      },
  
      proceedMarkAsDone() {
        this.showMarkDoneModal = false;
        this.formData.userRating = 0;
        this.formData.completionFeedback = "";
        this.showCompletedModal = true;
      },
  
      closeCompletedModal() {
        this.showCompletedModal = false;
        this.selectedJob = {};
        this.formData.userRating = 0;
        this.formData.completionFeedback = "";
      },
  
      setRating(rating) {
        this.formData.userRating = rating;
      },
  
      async submitCompletion() {
        const index = this.currentJobs.findIndex(
          (j) => j.id === this.selectedJob.id
        );
        if (index !== -1) {
          const completedJob = this.currentJobs.splice(index, 1)[0];
          completedJob.status = "completed";
          completedJob.has_rated = false;
          completedJob.completion_date = new Date().toISOString();
          this.historyJobs.unshift(completedJob);
          this.activeTab = "history";
        }
        this.closeCompletedModal();
      },
  
      // RESCHEDULE MODAL METHODS
      openRescheduleModal(job) {
        this.selectedJob = job;
        this.formData.rescheduleDate = "";
        this.formData.rescheduleTime = "";
        this.showRescheduleModal = true;
      },
  
      closeRescheduleModal() {
        this.showRescheduleModal = false;
        this.selectedJob = {};
        this.formData.rescheduleDate = "";
        this.formData.rescheduleTime = "";
      },
  
  
      // DECLINE MODAL METHODS
      openDeclineModal(job) {
        this.selectedJob = job;
        this.formData.selectedDeclineOption = "";
        this.formData.declineOtherReason = "";
        this.showDeclineModal = true;
      },
  
      closeDeclineModal() {
        this.showDeclineModal = false;
        this.selectedJob = {};
        this.formData.selectedDeclineOption = "";
        this.formData.declineOtherReason = "";
      },
  
      selectDeclineReason(reason) {
        this.formData.selectedDeclineOption = reason;
        if (reason !== "Other") {
          this.formData.declineOtherReason = "";
        }
      },
  
  
  
      // RATING MODAL METHODS
      openRatingModal(job) {
        console.log("Opening rating modal for:", job);
        this.ratingJobData = job;
        this.formData.userRating = 0;
        this.formData.completionFeedback = "";
        this.showRatingModal = true;
      },
  
      closeRatingModal() {
        this.showRatingModal = false;
        this.ratingJobData = {};
        this.formData.userRating = 0;
        this.formData.completionFeedback = "";
      },
  
      async submitRating() {
        this.ratingJobData.has_rated = true;
        this.ratingJobData.your_rating = this.formData.userRating;
        this.closeRatingModal();
      },
      async requestAction(actionType) {
        this.responseLoading = true;
        this.actions = actionType;
        if(this.actions === 'reschedule') {
          if(this.dateBooked == '') {
            this.responseLoading = false;
            return this.$toast.error('Please select date');
          }
          if(this.timeBooked == '') {
            this.responseLoading = false;
            return this.$toast.error('Please select time');
          }
  
        }
        try {
          const body = {
            id: this.jobID,
            action: this.actions,
            schedule_date: this.dateBooked,
            schedule_start_time: this.timeBooked,
          }
          await agentProfile.vendorRespond(JSON.stringify(body)).then(res => {
            this.responseLoading = false;
            // console.log("Response data", res);
            if(res.success) {
              this.$toast.success("SUCCESS");
              if(this.actions == 'reschedule') {
                $("#rescheduleModal")
                    .removeClass("fade")
                    .modal("hide");
              }
              this.getAllJobs();
            }
            if(res.error) {
              this.$toast.error(res.error);
            }
          }).catch((error) => {
            this.responseLoading = false;
            console.log("Error submitting data:", error);
            this.$toast.error("Error submitting");
          });
        } finally {
          console.log("closed");
        }
      },
  
          async cancelRequest() {
        this.loading = true;
        if(this.selectedReason == "") {
          this.loading = false;
          return this.$toast.error("Select reason for cancellation");
        }
        let body = {
          id: this.jobID,
          reason: this.selectedReason,
        };
        await vendorJobs.
        vendorDecline(JSON.stringify(body))
          .then((res) => {
            this.loading = false; 
            if(res.success) {
              this.$toast.success("Schedule cancelled");
            
              this.getCurrentJobs();
            if(res.error) {
              this.$toast.error(res.error);
            }}
          }).catch((error) => {
            this.loading = false;
            console.log("Error submitting data:", error);
            this.$toast.error("Error submitting");
          })
            .finally(()=>{
              this.closeDeclineModal()
            })
      },
  
  
      async getCurrentJobs() {
        this.loading = true;
  
        // let userID = this.$store.getters.getUser.id;
  
        vendorJobs
          .currentJobs()
          .then((data) => {
            console.log("current jobs", data);
            this.currentJobs = data.jobs;
  
            console.log("updated jobs", this.currentJobs);
          })
          .catch((error) => {
            console.log("Error", error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      async getAllJobs() {
        this.loading = true;
  
        // let userID = this.$store.getters.getUser.id;
  
        vendorJobs
          .allJobs()
          .then((data) => {
            (this.declinedNum = data.declined),
              (this.historyNum = data.history),
              (this.newRequestNum = data.new_request),
              (this.currentJobsNum = data.current_jobs);
            this.newRequests = data.jobs;
            console.log("all jobs", this.newRequests);
          })
          .catch((error) => {
            console.log("Error", error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  
    mounted() {
      this.getCurrentJobs();
      this.getAllJobs();
    },
  };
  </script>
  
  <style>
  * {
    box-sizing: border-box;
    font-family: "Lato", sans-serif;
    padding: 0;
    margin: 0;
  }
  .loading-screen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .job-management {
    min-height: 100vh;
    width: 80%;
  }
  
  .main-content {
    width: 100%;
    background: #fff;
    max-width: none;
    padding: 32px 40px;
    border-radius: 24px;
    margin-left: 80px;
  }
  
  .page-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 32px;
    color: #1a1a1a;
  }
  
  .tab-navigation {
    display: flex;
    border-bottom: 2px solid #e9eaeb;
    margin-bottom: 32px;
    overflow-x: auto;
  }
  
  .tab-button {
    background: none;
    border: none;
    padding: 10px 5px;
    margin-right: 48px;
    font-size: 16px;
    color: #555c74;
    cursor: pointer;
  
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
  }
  
  .tab-button.active {
    color: #0033ea;
    border-bottom-color: #0033ea;
    font-weight: 500;
  }
  
  .tab-count {
    color: #555c74;
    border: 1px solid #e9eaeb;
    background: #fafafa;
  
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 14px;
    min-width: 20px;
    text-align: center;
    font-weight: 500 !important;
  }
  
  .tab-button.active,
  .tab-count.active {
    color: #0033ea !important;
    font-weight: 600;
  }
  
  .tab-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 80px 20px;
    border-radius: 24px;
    text-align: center;
    background-color: #FAFAFA !important;
  }
  
  .empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.6;
  }
  
  .empty-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 8px;
    font-family: "Lato", sans-serif;
  }
  
  .empty-description {
    font-size: 14px;
    color: #6b7280;
    max-width: 400px;
    line-height: 1.5;
    font-family: "Lato", sans-serif;
  }
  
  .job-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #f1f5f9;
  }
  
  .job-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  
  .job-info {
    flex: 1;
  }
  
  .job-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 6px;
    color: #1a1a1a;
  }
  
  .job-date {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 4px;
  }
  
  .rating-info {
    font-size: 14px;
    color: #6b7280;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
  }
  
  .details-toggle {
    background: none;
    border: none;
    color: #6b7280;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-family: "Lato", sans-serif;
    padding: 4px 8px;
  }
  
  .chevron {
    transition: transform 0.2s ease;
    font-size: 12px;
  }
  
  .chevron.expanded {
    transform: rotate(180deg);
  }
  
  .job-actions {
    display: flex;
    flex-direction: row;
    gap: 12px;
    margin-bottom: 16px;
  }
  
  .btn {
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    font-family: "Lato", sans-serif;
  }
  
  .btn-primary {
    background-color: #0033ea;
    color: white;
    border-color: #0033ea;
  }
  
  .btn-red {
    background-color: red;
    color: #fff;
  }
  
  .btn-secondary {
    background-color: #f8fafc;
    color: #475569;
    border-color: #e2e8f0;
  }
  
  .btn-outline {
    background-color: transparent;
    color: #6b7280;
    border-color: #d1d5db;
  }
  
  .btn-full {
    width: 100%;
  }
  
  .btn:disabled {
    background-color: #f9fafb !important;
    color: #9ca3af !important;
    border-color: #e5e7eb !important;
    cursor: not-allowed !important;
  }
  
  .job-details {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #f1f5f9;
  }
  
  .customer-profile {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .customer-info {
    flex: 1;
  }
  
  .customer-name {
    font-weight: 600;
    margin-bottom: 6px;
    color: #1a1a1a;
    font-size: 16px;
  }
  
  .rating {
    display: flex;
    align-items: center;
    gap: 2px;
  }
  
  .star {
    color: #d1d5db;
    font-size: 16px;
  }
  
  .star.filled {
    color: #fbbf24;
  }
  
  .star.small {
    font-size: 12px;
  }
  
  .rating-value {
    font-size: 14px;
    color: #6b7280;
    margin-left: 6px;
    font-weight: 500;
  }
  
  .detail-tabs {
    display: flex;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 20px;
  }
  
  .detail-tab {
    background: none;
    border: none;
    padding: 12px 0;
    margin-right: 32px;
    font-size: 14px;
    color: #6b7280;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    font-family: "Lato", sans-serif;
    font-weight: 500;
  }
  
  .detail-tab.active {
    color: #0033ea;
    border-bottom-color: #0033ea;
  }
  
  .job-description {
    color: #6b7280;
    line-height: 1.6;
    margin-bottom: 20px;
    font-size: 14px;
  }
  
  .see-more {
    color: #0033ea;
    cursor: pointer;
    font-weight: 500;
  }
  
  .detail-grid {
    display: grid;
    gap: 16px;
  }
  
  .detail-row {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 8px 0;
  }
  
  .detail-label {
    font-size: 14px;
    color: #555c74;
    font-weight: 400;
  }
  
  .detail-value {
    font-size: 14px;
    font-weight: 600;
    color: #2b3352;
  }
  
  .image-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .job-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
  }
  
  /* SIMPLE MODAL STYLES - BULLETPROOF APPROACH */
  .simple-modal-backdrop {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background: rgba(0, 0, 0, 0.6) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 999999 !important;
    padding: 20px !important;
  }
  
  .simple-modal-content {
    background: white !important;
    border-radius: 12px !important;
    width: 100% !important;
    max-width: 500px !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }
  
  .simple-modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 24px 24px 0 24px !important;
    border-bottom: 1px solid #f1f5f9 !important;
    margin-bottom: 0 !important;
  }
  
  .simple-modal-header h3 {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #1a1a1a !important;
    margin: 0 !important;
  }
  
  .simple-close-btn {
    background: none !important;
    border: none !important;
    font-size: 24px !important;
    color: #6b7280 !important;
    cursor: pointer !important;
    padding: 8px !important;
    width: 40px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 6px !important;
  }
  
  .simple-close-btn:hover {
    background-color: #f9fafb !important;
  }
  
  .simple-modal-body {
    padding: 24px !important;
  }
  
  .simple-modal-footer {
    padding: 0 24px 24px 24px !important;
    display: flex !important;
    gap: 12px !important;
    border-top: 1px solid #f1f5f9 !important;
    margin-top: 24px !important;
    padding-top: 24px !important;
  }
  
  .text-center {
    text-align: center !important;
  }
  
  .request-info {
    margin-bottom: 24px !important;
  }
  
  .request-title {
    font-weight: 500 !important;
    color: #1a1a1a !important;
    margin-bottom: 8px !important;
  }
  
  .request-details {
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    color: #6b7280 !important;
    font-size: 14px !important;
  }
  
  .form-group {
    margin-bottom: 20px !important;
  }
  
  .form-group label {
    display: block !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #374151 !important;
    margin-bottom: 8px !important;
  }
  
  .form-group textarea,
  .form-group input {
    width: 100% !important;
    padding: 12px !important;
    border: 1px solid #d1d5db !important;
    border-radius: 8px !important;
    font-size: 14px !important;
    font-family: "Lato", sans-serif !important;
  }
  
  .form-group textarea {
    resize: vertical !important;
    min-height: 100px !important;
  }
  
  .form-group textarea:focus,
  .form-group input:focus {
    outline: none !important;
    border-color: #2563eb !important;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
  }
  
  .success-icon {
    width: 64px !important;
    height: 64px !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 32px !important;
    color: white !important;
    margin: 0 auto 20px auto !important;
  }
  
  .star-rating {
    display: flex !important;
    justify-content: center !important;
    gap: 8px !important;
    margin: 24px 0 !important;
  }
  
  .rating-star {
    font-size: 22px !important;
    color: #d1d5db !important;
    cursor: pointer !important;
    transition: color 0.2s !important;
  }
  
  .rating-star.active {
    color: #fbbf24 !important;
  }
  
  .rating-star:hover {
    color: #fbbf24 !important;
  }
  
  .current-schedule {
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    color: #6b7280 !important;
    font-size: 14px !important;
    margin-bottom: 24px !important;
    padding: 12px !important;
    border-radius: 8px !important;
  }
  
  .job-info-header {
    margin-bottom: 24px !important;
  }
  
  .job-info-header > div:first-child {
    font-weight: 500 !important;
    color: #1a1a1a !important;
    margin-bottom: 8px !important;
  }
  
  .job-info-header > div:last-child {
    display: flex !important;
    align-items: center !important;
    gap: 16px !important;
    color: #6b7280 !important;
    font-size: 14px !important;
  }
  
  .radio-group {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
  }
  
  .radio-group label {
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    cursor: pointer !important;
    padding: 8px 0 !important;
    margin-bottom: 0 !important;
  }
  
  .radio-group input[type="radio"] {
    width: 16px !important;
    height: 16px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  @media (max-width: 1200px) {
    .main-content {
      width: 100%;
      /* margin-left:0; */
    }
  }
  @media (max-width: 768px) {
    .main-content {
      padding: 20px 24px;
      width: 100%;
  
      margin-left: 0;
      margin-top: 20px;
    }
  
    .job-header {
      flex-direction: column;
      gap: 12px;
    }
  
    .job-management {
      width: 100%;
    }
  
    .page-title {
      font-size: 24px;
      margin-bottom: 24px;
    }
  
    .btn {
      width: 100%;
    }
  
    .detail-row {
      grid-template-columns: 1fr;
      gap: 4px;
    }
  
    .image-grid {
      grid-template-columns: 1fr;
    }
  
    .simple-modal-footer {
      flex-direction: column !important;
    }
  
    .simple-modal-footer .btn {
      width: 100% !important;
    }
    .customer-profile {
      flex-direction: column;
      align-items: flex-start;
      text-align: center;
    }
  }
  
  @media (max-width: 480px) {
    .job-actions {
      flex-direction: column;
    }
  }
  </style>